import api from '../api/api';

// reducers
import dashboardDictionariesReduces from './dictionaries/slice';
import dashboardReducer from '../hoc/dashboard/store/slice';

// middlewares
import dashboardMiddleware from '../hoc/dashboard/store/middleware';

export const dashboardReducers = {
  dashboardApi: api.reducer,
  dashboardDictionaries: dashboardDictionariesReduces,
  dashboard: dashboardReducer,
};

export const dashboardApi = [api.middleware, dashboardMiddleware.middleware];
